import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'utils/baseQuery';
import { METHODS } from 'config';

interface TeamStatisticsQuery {
  fromDate?: string;
  toDate?: string;
}

interface TeamStatisticsResponse {
  stats: any[];
}

const TeamStatisticsApi = createApi({
  reducerPath: 'team-statistics-api',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    teamStatistics: builder.query<TeamStatisticsResponse, TeamStatisticsQuery>({
      query: (body) => ({
        url: '/dashboard/team-statistics',
        method: METHODS.post,
        body,
      }),
    }),
  }),
});

export const { useTeamStatisticsQuery } = TeamStatisticsApi;
export { TeamStatisticsApi };
